import { render } from "./courseInfo.vue?vue&type=template&id=98248a50&scoped=true"
import script from "./courseInfo.vue?vue&type=script&lang=js"
export * from "./courseInfo.vue?vue&type=script&lang=js"

import "./courseInfo.vue?vue&type=style&index=0&id=98248a50&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98248a50"]])

export default __exports__